import React from "react";
import ReactDOM from "react-dom/client";
import { CssBaseline, GlobalStyles, ThemeProvider } from "@mui/material";
import App from "./App";
import theme from "./theme";

const globalStyles = (
  <GlobalStyles
    styles={{
      ":root": { colorScheme: "light" },
      "*": { boxSizing: "border-box" },
      "html, body, #root": {
        margin: 0,
        minHeight: "100%",
        backgroundColor: "#FFF8F0",
        scrollBehavior: "smooth",
      },
      body: {
        overflowX: "hidden",
        fontFamily: "'Nunito', sans-serif",
        color: "#1B1F3B",
      },
      a: { color: "inherit", textDecoration: "none" },
      img: { display: "block", maxWidth: "100%" },

      /* ── Global Animations ── */
      "@keyframes floatY": {
        "0%":   { transform: "translateY(0px)" },
        "50%":  { transform: "translateY(-14px)" },
        "100%": { transform: "translateY(0px)" },
      },
      "@keyframes floatYSlow": {
        "0%":   { transform: "translateY(0px)" },
        "50%":  { transform: "translateY(-20px)" },
        "100%": { transform: "translateY(0px)" },
      },
      "@keyframes bounce": {
        "0%, 100%": { transform: "translateY(0)" },
        "40%":      { transform: "translateY(-18px)" },
        "60%":      { transform: "translateY(-10px)" },
      },
      "@keyframes wiggle": {
        "0%, 100%": { transform: "rotate(-5deg)" },
        "50%":      { transform: "rotate(5deg)" },
      },
      "@keyframes wiggleFast": {
        "0%, 100%": { transform: "rotate(-8deg)" },
        "50%":      { transform: "rotate(8deg)" },
      },
      "@keyframes rotateSlow": {
        "0%":   { transform: "rotate(0deg)" },
        "100%": { transform: "rotate(360deg)" },
      },
      "@keyframes rotateCCW": {
        "0%":   { transform: "rotate(0deg)" },
        "100%": { transform: "rotate(-360deg)" },
      },
      "@keyframes pop": {
        "0%":   { transform: "scale(0.8)", opacity: 0 },
        "60%":  { transform: "scale(1.08)" },
        "100%": { transform: "scale(1)",   opacity: 1 },
      },
      "@keyframes slideUp": {
        "0%":   { transform: "translateY(40px)", opacity: 0 },
        "100%": { transform: "translateY(0)",    opacity: 1 },
      },
      "@keyframes slideLeft": {
        "0%":   { transform: "translateX(40px)", opacity: 0 },
        "100%": { transform: "translateX(0)",    opacity: 1 },
      },
      "@keyframes slideRight": {
        "0%":   { transform: "translateX(-40px)", opacity: 0 },
        "100%": { transform: "translateX(0)",     opacity: 1 },
      },
      "@keyframes pulse": {
        "0%, 100%": { transform: "scale(1)" },
        "50%":      { transform: "scale(1.06)" },
      },
      "@keyframes starSpin": {
        "0%":   { transform: "rotate(0deg) scale(1)" },
        "50%":  { transform: "rotate(180deg) scale(1.2)" },
        "100%": { transform: "rotate(360deg) scale(1)" },
      },
      "@keyframes blink": {
        "0%, 100%": { opacity: 1 },
        "50%":      { opacity: 0.2 },
      },
      "@keyframes drawLine": {
        "0%":   { strokeDashoffset: 1000 },
        "100%": { strokeDashoffset: 0 },
      },
      "@keyframes scaleX": {
        "0%":   { transform: "scaleX(0)" },
        "100%": { transform: "scaleX(1)" },
      },
      "@keyframes numberCount": {
        "0%":   { opacity: 0, transform: "translateY(20px)" },
        "100%": { opacity: 1, transform: "translateY(0)" },
      },
    }}
  />
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {globalStyles}
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
